import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NotificationCenterService } from './notification-center.service';

const FALLBACK_ROUTE = '/dashboard';

/**
 * `/notifications` is no longer a page — the notification center is a slide-over.
 * The path is kept because it is the allow-listed destination the service worker
 * hands to a clicked push notification (see `service-worker-support.ts`), so the
 * guard opens the panel and sends the user back to whatever they were viewing.
 */
export const notificationCenterGuard: CanActivateFn = () => {
	const router = inject(Router);
	inject(NotificationCenterService).openPanel();

	const current = router.url.split('?')[0];
	return router.parseUrl(
		current && current !== '/' && current !== '/notifications' ? router.url : FALLBACK_ROUTE,
	);
};
